import { getLayoutShapeId } from "../getLayoutShapeId";
import { polygonAreaM2 } from "../polygonAreaM2";
import { getRoomLabelText } from "../getRoomLabelText";
import { NO_ZONE_RGB } from "../constants";
import type { BuildRoomShapes } from "./types";

export const buildRoomShapes: BuildRoomShapes = ({
  rooms,
  zones,
  roomColorById,
  metersPerPdfPoint,
}) => {
  const zoneNameById = new Map(zones.map((zone) => [zone.id, zone.name]));

  return rooms.map((room) => {
    const areaM2 = polygonAreaM2({ points: room.points, metersPerPdfPoint });
    return {
      id: getLayoutShapeId({ kind: "room", id: room.id }),
      rings: [room.points],
      rgb: roomColorById.get(room.id) ?? NO_ZONE_RGB,
      label: {
        // Measured from the outline when the page has a scale, else the area printed on the plan.
        text: getRoomLabelText({
          name: room.name,
          areaM2: areaM2 ?? room.statedAreaM2,
        }),
        points: room.points,
      },
      tooltip: {
        kind: "room",
        name: room.name,
        areaM2,
        statedAreaM2: room.statedAreaM2,
        zoneName:
          room.zoneId === null ? null : (zoneNameById.get(room.zoneId) ?? null),
      },
    };
  });
};
